import { Injectable } from "@angular/core";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { AvverkningsanmalanTyp } from "../atgarder/atgard-avverkningsanmalan/avverkningsanmalan-typ";
import { Atgard } from "../models/atgard-models";
import { Avverkningsanmalan } from "../models/avverkningsanmalan-models";
import { Atgardstyper } from "../models/virkeskopAtgardstyper";

@Injectable({
    providedIn: "root"
})

export class AvverkningsanmalanService {

    canHandleAvverkningsanmalan(atg: Atgard): boolean {
        return Atgardstyper.avvAnmalanTyper.some(x => x === atg.atgardstyp);
    }

    hasActiveAnmalanWebb(atg: Atgard, avverkningsanmalan: Avverkningsanmalan): boolean {
        if (!atg.id) {
            return false;
        }

        if (avverkningsanmalan?.typ === AvverkningsanmalanTyp.anmalanWeb &&
            ObjectUtils.hasValue(avverkningsanmalan?.godkantDatum) &&
            this.canHandleAvverkningsanmalan(atg)) {
            return true;
        }

        return false;
    }
}
